const BRAND_TO_SALESFORCE = {
  FIAT: "Fiat",
  FORD: "Ford",
  PEUGEOT: "Peugeot",
  HYUNDAI: "Hyundai",
  JEEP: "Jeep",
  RAM: "RAM",
  GAC: "GAC",
};

const omitEmpty = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );

const clip = (value, max) => {
  if (!value) return undefined;
  const text = String(value).trim();
  return text.length > max ? text.slice(0, max) : text;
};

export const splitFullName = (fullName = "") => {
  const parts = String(fullName)
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length === 0) {
    return {};
  }

  if (parts.length === 1) {
    return { LastName: clip(parts[0], 80) };
  }

  return {
    FirstName: clip(parts.slice(0, -1).join(" "), 40),
    LastName: clip(parts[parts.length - 1], 80),
  };
};

export const mapBrandToSalesforce = (brand) => {
  if (!brand) return undefined;
  const key = String(brand).trim().toUpperCase();
  return BRAND_TO_SALESFORCE[key];
};

export const mapFormDataToSalesforce = (formData = {}) => {
  const name = formData.name || formData.nombre || "";
  const email = formData.email || "";
  const phone = String(formData.phone || formData.celular || "").replace(/\D/g, "");
  const brand = mapBrandToSalesforce(formData.brand || formData.marcaInteres);

  return omitEmpty({
    ...splitFullName(name),
    PersonType__c: "NaturalPerson",
    Email: email,
    MobileCountryCode__c: phone ? "54" : undefined,
    MobilePhone: phone || undefined,
    Branch__c: formData.branch || "CORDOBA",
    BusinessBrand__c: brand,
    SalesType__c: "Venta_Tradicional",
    InquiryReason__c: "Venta_Tradicional",
    Segment__c: "Particular",
    LeadSource: "Web",
    WhatsappOptIn__c: true,
    Country: "AR",
  });
};
